export default __webpack_public_path__ + "static/media/info-icon.143e58bb.svg";